import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
// common components
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import Loader from './../../../common/Loader/Loader';
// scss
import './QuestionList.scss';

const QuestionList = ({ manageQuestion, questionList }) => {

	const viewMore = (url) => {
		window.open(`://${url}`, '_blank');
	}

	if (questionList && questionList.length > 0) {
		return (
			<div className="QuestionList">
				{questionList.map((item, index) => (
					<div className="ques-list" key={item.id}>
						<div className="ques-edit">
							<div className="question-no">
								{index + 1}
							</div>
							<div className="question-details">
								<div className="heading">{item.question}</div>
								<div className="cardview-actions">
									<div className="line" />
									<CustomButton
										iconOnly
										iconName='edit'
										onClick={() => manageQuestion(true, 'edit', item.id)}
									/>
									<CustomButton
										iconOnly
										iconName='delete'
										onClick={() => manageQuestion(true, 'delete', item.id)}
									/>
								</div>
							</div>
						</div>
						<div className="row options">
							{item.options.map((option, i) => (
								<div className="col-md-6" key={i}>
									<div>
										<span className={`option-index ${option.correct_answer === 'Y' ? 'true' : ''}`}>{(i + 10).toString(36)}</span>
										<div>
											{option.option_value}
										</div>
									</div>
								</div>
							))}
						</div>
						<div className="other-qdetails">
							<div>
								<div className='label'>reason</div>
								<div className='value' dangerouslySetInnerHTML={{ __html: item.reason }} />
							</div>
							{item.url && (
								<div>
									{item.url.match(/http/g) ?
										<div className="referencelink"><a rel={'external'} target="_blank" href={`${item.url}`} >
											Reference Link
									    </a></div>
										:
										<div className="referencelink"><a href={`//${item.url}`} target="_blank">
											Reference Link
									</a></div>
									}
								</div>
							)}
							{/* {item.url && (
								<CustomButton
									plain
									name='View More....'
									onClick={() => viewMore(item.url)}
								/>
							)} */}
						</div>
					</div>
				))}
			</div>
		);
	}
	return (<Loader />);
}

QuestionList.propTypes = {
	manageQuestion: PropTypes.func,
	questionList: PropTypes.instanceOf(Array)
};

QuestionList.defaultProps = {
	manageQuestion: () => { },
	questionList: []
};

export default QuestionList;



// WEBPACK FOOTER //
// ./components/ModuleQuestion/QuestionList/QuestionList.js